import React from 'react';
import { checkPermission } from 'utils/permission'

const Permission = ({ permission = [], message, every,children }) => {
  const can = checkPermission(permission, every);
  
  return can ? <>{children}</> : <>{message}</>;
};

export default Permission;
